import React, { Component } from 'react';
import CancelUrl from '../CancelUrl/CancelUrl';
import FooterLinks from './FooterLinks';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { FormattedMessage } from 'react-intl';
import './Footer.less';
import { showEscapeHatch } from '../EscapeHatch/EscapeHatchActions';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import get from 'lodash/get';
import { PAGE_NAME } from '../../config/GBConstants';

const LOCALE_PREFIX = 'GB/components/Footer/Footer';

export class Footer extends Component {
    static propTypes = {
        dispatchCancelFPTI: PropTypes.func,
        errorType: PropTypes.string,
        pageName: PropTypes.string,
        showEscapeHatch: PropTypes.func,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        cancelUrlProvided: PropTypes.bool,
        // Passed in props
        cookieBannerAvailable: PropTypes.bool,
        showCancelUrl: PropTypes.bool
    };

    static defaultProps = {
        cookieBannerAvailable: false,
        showCancelUrl: true,
        cancelUrlProvided: true
    };

    handleShowEscapeHatch = () => {
        this.props.showEscapeHatch();
    };

    render() {
        const {
            errorType,
            showCancelUrl,
            cookieBannerAvailable,
            flow,
            cancelUrlProvided,
            pageName
        } = this.props;
        const isInvalidFlow = errorType === 'invalidFlow';
        const isTesla = flow === FLOW_TYPE.TESLA;

        const extraCancelProps = {};
        if ([PAGE_NAME.CYCO_PAGE, PAGE_NAME.NEWCUST_PAGE].indexOf(pageName) >= 0) {
            // use this fpti template since we're not going to show the escape hatch
            extraCancelProps.fptiEvent = {
                stateName: `pp_credit_${pageName}`,
                transitionName: `cancel_pp_credit_${pageName}`
            };
        } else { // show the escape hatch for all other pages
            extraCancelProps.customOnClick = this.handleShowEscapeHatch;
        }

        return (
            <footer id="cue-footer">
                <div className={`cue-footer-container ${cookieBannerAvailable ? 'cookieBanner' : ''}`}>
                    {showCancelUrl && !isInvalidFlow && cancelUrlProvided && (
                        <CancelUrl
                            id="footer_cancelUrl"
                            className="footer-cancelurl-apply backLink"
                            {...extraCancelProps}
                        />
                    )}
                    {!isTesla && <FooterLinks />}

                    <div className="disclosure">
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.disclosure`}
                        />
                    </div>

                    {isTesla && <FooterLinks />}
                </div>
            </footer>
        );
    }
}

export const mapStateToProps = state => ({
    errorType: state.serverData.errorType,
    cookieBannerAvailable: state.serverData.cookieBannerAvailable || false,
    pageName: state.skeletonPage.currentPage,
    flow: get(state, 'serverData.flow'),
    cancelUrlProvided: get(state, 'serverData.cancelUrlProvided')
});

export const mapDispatchToProps = dispatch => ({
    dispatchCancelFPTI(pathName) {
        dispatch(trackTransition(`apply_pp_credit_${pathName}`, `cancel_and_return_apply_pp_credit_${pathName}`));
    },
    showEscapeHatch() {
        dispatch(showEscapeHatch());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
